import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import "@/pages/Home.css";

// Editorial CLAÈ nav — replaces the old shopping-header everywhere.
// Cart is still reachable via the icon button (retained for booking flow).
export default function Header({ minimal = false, content }) {
  const { cartCount } = useApp();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  // Header nav is the same on every page (Home included). The footer's own
  // CMS-editable nav is intentionally NOT reused here so trimming the footer
  // doesn't strip links from the site-wide header.
  const headerLinks = content?.header?.links;

  const links = headerLinks && headerLinks.length ? (
    <>
      {headerLinks.map((l, i) => (
        <Link key={i} to={l.href} onClick={() => setOpen(false)}
              data-testid={`nav-${(l.label || "").toLowerCase().replace(/\W/g, "")}`}>
          {l.label}
        </Link>
      ))}
    </>
  ) : (
    <>
      <Link to="/treatments" data-testid="nav-treatments" onClick={() => setOpen(false)}>Treatments</Link>
      <Link to="/about" data-testid="nav-about" onClick={() => setOpen(false)}>About</Link>
      <Link to="/contact#model-days" data-testid="nav-models" onClick={() => setOpen(false)}>Model Days</Link>
      <Link to="/faqs" data-testid="nav-faqs" onClick={() => setOpen(false)}>FAQs</Link>
      <Link to="/contact" data-testid="nav-contact" onClick={() => setOpen(false)}>Contact</Link>
    </>
  );
  const bookHref = content?.hero?.cta_href || "/treatments";

  return (
    <header className="clae-nav" data-testid="site-header">
      <div className="clae-nav__inner">
        <Link to="/" data-testid="logo-link" className="font-serif text-2xl tracking-tight text-stone-900" aria-label="CLAÈ home"
              style={{ padding: "8px 4px", margin: "-8px -4px" }}>
          CLAÈ
        </Link>

        {!minimal && <nav className="clae-nav__links">{links}</nav>}

        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          {/* Header CTA swapped with the hero CTA — this button now
              routes clients to the existing Treatments booking flow
              (full catalogue). Label and href are hardcoded here so
              the swap stays consistent across pages. */}
          <Link to="/treatments"
                data-testid="nav-book-cta" className="clae-nav__cta">
            Book Your Treatments
          </Link>
          <button
            data-testid="cart-button" onClick={() => nav("/cart")} aria-label="Cart"
            style={{ background: "none", border: "none", cursor: "pointer", position: "relative", padding: 8, color: "var(--ink)" }}
          >
            <ShoppingBag size={18} />
            {cartCount > 0 && (
              <span
                data-testid="cart-count"
                style={{ position: "absolute", top: -2, right: -2, background: "var(--champagne)", color: "#fff", fontSize: 10, minWidth: 16, height: 16, borderRadius: 8, display: "inline-flex", alignItems: "center", justifyContent: "center", padding: "0 4px" }}
              >
                {cartCount}
              </span>
            )}
          </button>
          {!minimal && (
            <button className="clae-nav__burger" data-testid="nav-burger" onClick={() => setOpen((v) => !v)} aria-label="Menu">
              {open ? <X size={20} /> : <Menu size={20} />}
            </button>
          )}
        </div>
      </div>
      {open && !minimal && (
        <div className="clae-nav__mobile" data-testid="nav-mobile">{links}</div>
      )}
    </header>
  );
}
